export default [
  { label: 'Dział floty', value: 'FLEET_DEPARTMENT' },
  { label: 'Dział samochodów osobowych', value: 'NEW_CARS_DEPARTMENT' },
  { label: 'Dział samochodów dostawczych', value: 'COMMERCIAL_VEHICLES_DEPARTMENT' },
  { label: 'Dział samochodów używanych', value: 'USED_CARS_DEPARTMENT' },
  { label: 'Dział serwisu', value: 'SERVICE_DEPARTMENT' },
  { label: 'Recepcja', value: 'RECEPTION_DEPARTMENT' },
  { label: 'Dział finansów', value: 'FINANCE_DEPARTMENT' },
]
